import React from "react";
import { Card } from "ui/components/card";
import { Separator } from "ui/components/separator";
import { Button } from "ui/components/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "ui/components/dropdown-menu";
import { Icon } from "components";
import { MENU, PLUS } from "icons";
import EntityIntegrationsLoader from "./loader";

export default function EntityIntegrationsCard({
  icon,
  title,
  description,
  isConnected,
  onConnect,
  onDelete,
  loading = false,
  isDeleting = false,
}) {
  if (loading) {
    return <EntityIntegrationsLoader />;
  }

  return (
    <Card className="h-max gap-0 border py-1 shadow-sm">
      <div className="space-y-4 p-4 md:p-6">
        <div className="flex items-center justify-between">
          <div className="text-foreground">
            <Icon icon={icon} className="size-10" />
          </div>
          {isConnected && onDelete ? (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="icon" disabled={isDeleting}>
                  <Icon icon={MENU} className="size-4" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                <DropdownMenuItem
                  className="cursor-pointer text-red-600 focus:text-red-600"
                  disabled={isDeleting}
                  onClick={onDelete}
                >
                  Delete
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          ) : null}
        </div>
        <div>
          <h3 className="text-lg font-semibold">{title}</h3>
        </div>
        {description ? (
          <p className="text-sm text-muted-foreground">{description}</p>
        ) : null}
      </div>
      <Separator />
      <div className="flex items-center justify-between px-4 py-4 md:px-6">
        {isConnected ? (
          <span className="text-sm text-muted-foreground">Connected</span>
        ) : (
          <Button className="gap-2" onClick={onConnect}>
            <Icon icon={PLUS} className="size-4 text-white" />
            Connect
          </Button>
        )}
      </div>
    </Card>
  );
}

export { EntityIntegrationsLoader };
